import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

// import Class from "./modals/classes";
import { useSelector } from "react-redux";
import BookingDetails from "./modals/booking/BookingDetails";
import BusinessProfileUpComplete from "./modals/businessProfile/BusinessProfileComplete";
import BusinessProfileUpSubscription from "./modals/businessProfile/BusinessProfileUpSubscription";
import BusinessProfileUpSubscriptionSuccess from "./modals/businessProfile/BusinessProfileUpSubscriptionSuccess";
import BusinessProfileUpSubscriptionUpgrade from "./modals/businessProfile/BusinessProfileUpSubscriptionUpgrade";
import AddNewClass from "./modals/classes/action/AddNewClass";
// import AllClassBooking from "./modals/classes/booking/AllClassBooking"; // replaced by BookingsPage (2026-10-28)
import BookingsPage from "./modals/classes/booking/BookingsPage";
// DORMANT (to be removed): legacy class detail page, no longer linked from My Classes.
// import ClassDetails from "./modals/classes/ClassDetails";
import ClassList from "./modals/classes/ClassList";
// Old My Members pages, replaced by members/MembersPage + members/MemberDetailPage. Kept for now, to be removed.
// import MyMembersDetail from "./modals/classes/mymembers/MyMembersDetail";
// import MyMembersList from "./modals/classes/mymembers/MyMembersList";
import MemberDetailPage from "./modals/classes/members/MemberDetailPage";
import MembersPage from "./modals/classes/members/MembersPage";
import PaymentReturnPage from "./modals/classes/members/PaymentReturnPage";
import ShortPayLinkPage from "./modals/classes/members/ShortPayLinkPage";
// Old News Feeds pages, replaced by newsfeed/NewsFeedPage (post page replaced by "Preview in app"). Kept for now, to be removed.
// import NewsFeedsDetail from "./modals/classes/newsfeed/NewsFeedsDetail";
// import NewsFeedsList from "./modals/classes/newsfeed/NewsFeedsList";
import NewsFeedPage from "./modals/classes/newsfeed/NewsFeedPage";
// Old My Products page, replaced by products/ProductsPage. Kept for now, to be removed.
// import ProductList from "./modals/classes/products/ProductList";
import ProductsPage from "./modals/classes/products/ProductsPage";
// Old My Schedule list page, replaced by MySchedule (week grid + list). Kept for now, to be removed.
// import ScheduleClassList from "./modals/classes/ScheduleClassList";
import MySchedule from "./modals/classes/MySchedule";
import PurchaseDetails from "./modals/classes/sessionPass/PurchaseDetails";
import SessionPassDetail from "./modals/classes/sessionPass/SessionPassDetail";
import TransactionsList from "./modals/classes/transactions/TransactionsList";
import BusinessProfileClassSession from "./modals/classes/view/BusinessProfileClassSession";
import Home from "./modals/dashboard/Home";
import SmallScreenNotAllow from "./modals/error/SmallScreenNotAllow";
import ForgotPassword from "./modals/forgotPassword";
import ResetPassword from "./modals/forgotPassword/ResetPassword";
import VerifyForgotPassword from "./modals/forgotPassword/Verify";
import LocationList from "./modals/myLocation/LocationList";
import BusinessPaymentProfile from "./modals/paymentProfile/BusinessPaymentProfile";
// import EditBusinessProfile / ViewBusinessProfile: old club profile pages, replaced by Account settings → Club (removed 2026-10-28)
import ManageOnlineBooking from "./modals/settings/manageOnlineBooking";
// Old Account Settings page, replaced by settings/accountSettings/AccountSettingsPage. Kept for now, to be removed.
// import MyAccount from "./modals/settings/myAccount/MyAccount";
import AccountSettingsPage from "./modals/settings/accountSettings/AccountSettingsPage";
import MyAppProfile from "./modals/settings/myApps";
import MyAvailableTime from "./modals/settings/myAvailableTime";
import SignIn from "./modals/signin";
import SignUp from "./modals/signup";
// import OnBording from "./modals/signup/onbording"; // old onboarding wizard, removed 2026-10-28 (/on-bording redirects to /start/plan)
import TwTest from "./modals/tailwind/TwTest";
import AddMyResource from "./modals/venueAndServices/myresource/AddMyResource";
import MyResourceList from "./modals/venueAndServices/myresource/MyResourceList";
import AddServices from "./modals/venueAndServices/services/action/AddServices";
import ServiceBookingDetails from "./modals/venueAndServices/services/booking/BookingDetails";
import ServiceScheduleList from "./modals/venueAndServices/services/ScheduleList";
import ServiceList from "./modals/venueAndServices/services/ServiceList";
import AddVenue from "./modals/venueAndServices/venue/AddVenue";
import VenueList from "./modals/venueAndServices/venue/VenueList";
import VerifyNumber from "./modals/verifyCredentials/VerifyNumber";
import PlanCheckout from "./modals/onboardingStart/PlanCheckout";
import OnboardingWelcome from "./modals/onboardingStart/Welcome";
import OnboardingClubDetails from "./modals/onboardingStart/ClubDetails";
import OnboardingPayouts from "./modals/onboardingStart/Payouts";
import { userState } from "./redux/reducers/userReducer";
import SignupWithPublickLink from "./modals/signupWithPublickLink";
import StripeCheckoutSessionsSuccessCancel from "./modals/checkout/StripeCheckoutSessionsSuccessCancel";
// Member portal (new design); the old MyConsumersDetail / ConsumersScheduleClassList / ConsumersProductList pages are no longer routed.
import MemberAccountPage from "./modals/consumer/portal/MemberAccountPage";
import MemberSchedulePage from "./modals/consumer/portal/MemberSchedulePage";
import WebshopPage from "./modals/consumer/portal/WebshopPage";
import ActivateAccountPage from "./modals/consumer/activate/ActivateAccountPage";
import GetAppPage from "./modals/consumer/activate/GetAppPage";
import TrialSchedulePage from "./modals/trial/TrialSchedulePage";
import TrialBookPage from "./modals/trial/TrialBookPage";
import TrialManagePage from "./modals/trial/TrialManagePage";
import ConsumersBookingDetails from "./modals/consumer/booking/ConsumersBookingDetails";
import UAConsumersProductList from "./modals/consumer/products/UAConsumersProductList";
// Club Stats moved to Home (/home/dashboard?view=…); /my-stats redirects there. Old pages kept for now, to be removed.
// import MyStats from "./modals/settings/myStats/MyStats";
// import ClubStatsPage from "./modals/settings/myStats/ClubStatsPage";

export default function Router() {
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const routes = [
    {
      path: "/",
      element: <SignIn navigation={navigate} />,
    },
    {
      path: "/signup",
      element: <SignUp navigation={navigate} />,
    },
    {
      path: "/signup/verifynumber",
      element: <VerifyNumber navigation={navigate} />,
    },
    {
      path: "/start/plan",
      element: <PlanCheckout navigation={navigate} />,
    },
    {
      path: "/start/checkout",
      element: <PlanCheckout navigation={navigate} step="checkout" />,
    },
    {
      path: "/start/welcome",
      element: <OnboardingWelcome navigation={navigate} />,
    },
    {
      path: "/start/club",
      element: <OnboardingClubDetails navigation={navigate} />,
    },
    {
      path: "/start/payouts",
      element: <OnboardingPayouts navigation={navigate} />,
    },
    {
      path: "/businessprofilesetup/done",
      element: <BusinessProfileUpComplete navigation={navigate} />,
    },
    {
      path: "/businessprofilesetup/subscription",
      element: <BusinessProfileUpSubscription navigation={navigate} />,
    },
    {
      path: "/my-subscription",
      element: <BusinessProfileUpSubscriptionUpgrade navigation={navigate} />,
    },
    {
      path: "/businessprofilesetup/subscription/upgrade",
      element: <BusinessProfileUpSubscriptionUpgrade navigation={navigate} />,
    },
    {
      path: "/businessprofilesetup/subscription/success",
      element: <BusinessProfileUpSubscriptionSuccess navigation={navigate} landFor="success" />,
    },
    {
      path: "/businessprofilesetup/subscription/cancel",
      element: <BusinessProfileUpSubscriptionSuccess navigation={navigate} landFor="cancel" />,
    },
    {
      path: "/myschedule/detail",
      element: <BusinessProfileClassSession navigation={navigate} />,
    },
    {
      path: "/businessprofile/view",
      element: <Navigate replace to="/my-account/company" />,
    },
    {
      path: "/businessprofile/update",
      element: <Navigate replace to="/my-account/company" />,
    },
    {
      path: "/home/dashboard",
      element: <Home navigation={navigate} />,
    },
    {
      path: "/myvenue",
      element: <VenueList navigation={navigate}
        profileFor="venue"
        title="My Venues" />,
    },
    {
      path: "/myvenue/add",
      element: <AddVenue navigation={navigate}
        profileFor="venue"
        title="My Venues" />,
    },
    {
      path: "/myvenue/update",
      element: <AddVenue navigation={navigate}
        profileFor="editvenue"
        title="Edit Venues" />,
    },
    {
      path: "/mylocation",
      element: <LocationList navigation={navigate}
        profileFor="location"
        title="My Location" />,
    },
    {
      // "Activate your account" button in the club's welcome email (members a club added)
      path: "/members/activate",
      element: <ActivateAccountPage />,
    },
    {
      // Free trial class for newcomers: the club's open schedule (link on the club's own website)
      path: "/trial",
      element: <TrialSchedulePage />,
    },
    {
      path: "/trial/book/:sessionId",
      element: <TrialBookPage />,
    },
    {
      // "Change or cancel" link in the trial SMS / email
      path: "/trial/manage",
      element: <TrialManagePage />,
    },
    {
      // One link for the FitClub app: App Store on iOS, Google Play on Android, both buttons elsewhere
      path: "/get-app",
      element: <GetAppPage />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword navigation={navigate} />,
    },
    {
      path: "/forgot-password/member",
      element: <ForgotPassword navigation={navigate} userType="student" />,
    },
    {
      path: "/forgot-password/verify",
      element: <VerifyForgotPassword navigation={navigate} />,
    },
    {
      path: "/forgot-password/reset",
      element: <ResetPassword navigation={navigate} />,
    },
    {
      path: "/payment/profile",
      element: <BusinessPaymentProfile navigation={navigate} screenView="full" />,
    },
    {
      path: "/booking/view",
      element: <BookingDetails navigation={navigate} />,
    },
    {
      path: "/myservices",
      element: (
        <ServiceList
          navigation={navigate}
          profileFor="service"
          title="My Services"
        />
      ),
    },
    {
      path: "/myservices/new",
      element: (
        <AddServices
          navigation={navigate}
          profileFor="service"
          title="Add New Services"
        />
      ),
    },
    {
      path: "/myservices/update",
      element: (
        <AddServices
          navigation={navigate}
          profileFor="editservice"
          title="Edit Services"
        />
      ),
    },
    {
      path: "/myservices/schedule",
      element: (
        <ServiceScheduleList
          navigation={navigate}
          profileFor="service"
          title="Schedule"
        />
      ),
    },
    {
      path: "/myservices/schedule/detail",
      element: (
        <ServiceBookingDetails
          navigation={navigate}
          profileFor="service"
          title="Schedule"
        />
      ),
    },
    {
      path: "/myresource",
      element: <MyResourceList navigation={navigate}
        profileFor="myresource"
        title="My Team" />,
    },
    {
      path: "/myresource/add",
      element: <AddMyResource navigation={navigate}
        profileFor="addmyresource"
        title="Add Team" />,
    },
    {
      path: "/myresource/update",
      element: <AddMyResource navigation={navigate}
        profileFor="editmyresource"
        title="Edit Team" />,
    },
    {
      path: "/my-available-time",
      element: (
        <MyAvailableTime
          navigation={navigate}
          title="My Available Time"
        />
      ),
    },
    {
      path: "/my-connected-apps",
      element: (
        <MyAppProfile
          navigation={navigate}
          title="My Available Time"
        />
      ),
    },
    {
      path: "/manage-online-booking",
      element: (
        <ManageOnlineBooking
          navigation={navigate}
          title="Manage Online Booking"
        />
      ),
    },
    {
      path: "/myclasses/new",
      element: (
        <ClassList navigation={navigate} profileFor="class" title="My Classes" openNew />
      ),
    },
    {
      path: "/myclasses",
      element: (
        <ClassList navigation={navigate} profileFor="class" title="My Classes" />
      ),
    },
    {
      path: "/myclasses/detail",
      // DORMANT: legacy ClassDetails page. Redirects to My Classes until it is removed.
      element: <Navigate replace to="/myclasses" />,
    },
    {
      path: "/myclasses/myschedule",
      element: (
        <MySchedule title="My Schedule" />
      ),
    },
    {
      path: "/small-screen-not-allow",
      element: (
        <SmallScreenNotAllow
          navigation={navigate}
          title="My Available Time"
        />
      ),
    },
    {
      path: "/class/sessionpasses/purchase",
      element: (
        <SessionPassDetail
          navigation={navigate}
          profileFor="class"
          title="Pass Detail"
        />
      ),
    },
    {
      path: "/purchase/view",
      element: <PurchaseDetails navigation={navigate} />,
    },
    {
      path: "/my-account",
      element: <AccountSettingsPage selectedTab="account" />,
    },
    {
      path: "/my-account/company",
      element: <AccountSettingsPage selectedTab="company" />,
    },
    {
      path: "/my-account/billing",
      element: <AccountSettingsPage selectedTab="billing" />,
    },
    {
      path: "/my-account/online-payment",
      element: <AccountSettingsPage selectedTab="online-payment" />,
    },
    {
      path: "/on-bording",
      element: <Navigate replace to="/start/plan" />,
    },
    {
      path: "/mymembers",
      element: <MembersPage title="My Members" />,
    },
    {
      path: "/mymembers/detail",
      element: <MemberDetailPage />,
    },
    {
      // public: short payment link a club sends (opens Stripe Checkout)
      path: "/p/:code",
      element: <ShortPayLinkPage />,
    },
    {
      // public: where a member lands after paying a payment link the club sent
      path: "/pay/done",
      element: <PaymentReturnPage landFor="done" />,
    },
    {
      path: "/pay/cancelled",
      element: <PaymentReturnPage landFor="cancelled" />,
    },
    {
      path: "/newsfeed",
      element: (
        <NewsFeedPage title="News Feeds" />
      ),
    },
    {
      path: "/newsfeed/detail",
      element: (
        <NewsFeedPage title="News Feeds" />
      ),
    },
    {
      path: "/products",
      element: (
        <ProductsPage title="My Products" />
      ),
    },
    {
      path: "/transactions",
      element: (
        <TransactionsList navigation={navigate} title="Transactions" />
      ),
    },
    {
      path: "/bookings",
      element: <BookingsPage title="Bookings" />,
    },
    {
      // old links (e.g. the old dashboard tile) open the new Bookings page
      path: "/all-bookings",
      element: <BookingsPage title="Bookings" />,
    },
    // student routes start
    {
      path: "/members/signin",
      element: <SignIn navigation={navigate} />,
    },
    {
      path: "/members/signup/:myBookingLink",
      element: (
        <SignupWithPublickLink navigation={navigate} title="Bookings" logFor="club" />
      ),
    },
    {
      path: "/members/signup",
      element: (
        <SignupWithPublickLink navigation={navigate} title="Bookings" logFor="tenant" />
      ),
    },
    {
      path: "/checkout/success",
      element: <StripeCheckoutSessionsSuccessCancel navigation={navigate} landFor="success" />,
    },
    {
      path: "/checkout/cancel",
      element: <StripeCheckoutSessionsSuccessCancel navigation={navigate} landFor="cancel" />,
    },
    {
      path: "/members/my-profile",
      element: <MemberAccountPage section="profile" />,
    },
    {
      path: "/members/purchases",
      element: <MemberAccountPage section="purchases" />,
    },
    {
      // Stripe Checkout returns here after a purchase in the Club Webshop
      path: "/members/purchases/success",
      element: <MemberAccountPage section="purchases" justBought />,
    },
    {
      path: "/members/bookings",
      element: <MemberAccountPage section="bookings" />,
    },
    // old addresses of the My Account tabs
    {
      path: "/members/my-profile/products",
      element: <Navigate replace to="/members/purchases" />,
    },
    {
      path: "/members/my-profile/bookings",
      element: <Navigate replace to="/members/bookings" />,
    },
    {
      path: "/members/schedule",
      element: (
        <MemberSchedulePage />
      ),
    },
    {
      path: "/members/webshop",
      element: <WebshopPage />,
    },
    {
      // Stripe Checkout "back" / cancel
      path: "/members/webshop/cancelled",
      element: <WebshopPage cancelled />,
    },
    {
      path: "/webshop_ua",
      element: (
        <UAConsumersProductList navigation={navigate} title="Webshop" />
      ),
    },
    {
      path: "/members/booking/view",
      element: <ConsumersBookingDetails navigation={navigate} />,
    },
    {
      path: "/my-stats",
      element: <Navigate to="/home/dashboard?view=members" replace />,
    },
    // student routes end
    {
      path: "/tw-test",
      element: <TwTest navigation={navigate} />,
    },
    {
      path: "*",
      element: <Navigate replace to={userReduxState.userData?.userType == "student" ? "/members/schedule" : "/home/dashboard"} />,
    },
  ];
  return (
    <Routes>
      {routes.map((route, idx) => (
        <Route key={idx} {...route} />
      ))}
    </Routes>
  );
}
